import { useContext } from "react";
import { motion } from "framer-motion";
import Button from "../button/Button";
import { UserContext } from "../context/UseContext";
import { useProfile } from "../../api/settings/profile";
import { Loader } from "../loader/Loader";
import { useNavigate } from "react-router-dom";
import { AppLayout } from "../../layout/AppLayout";
import { Arrow } from "../svg/Wallet/Wallet";
import { Camera } from "../svg/Settings";
import { Card } from "../Card";
import { BaseInput } from "../input/baseInput";
import { Avatar } from "../Avatar";
import { PhoneInput } from "../input/phoneInput";

function UserProfile({ play, stop }) {
  // const [sound, setSound] = useState(true);
  const { profile } = useContext(UserContext);
  const navigate = useNavigate();
  const {
    handleEditProfile,
    firstName,
    setFirstName,
    lastName,
    setLastName,
    telePhone,
    setTelephone,
    isLoading,
    handleUploadProfileImage,
    isUploading,
  } = useProfile();

  const hasAnyValue =
    firstName?.trim() !== "" ||
    lastName?.trim() !== "" ||
    telePhone?.fullNumber?.trim() !== "";

  const isValid = hasAnyValue;

  const handlePhoneChange = (e) => {
    const phoneInfo = e.target.value;
    setTelephone(phoneInfo);
  };

  return (
    <AppLayout noNav bg={"!bg-[#F8F8F8]"}>
      <div className="pt-10 pb-7 px-5 min-h-screen flex flex-col">
        <motion.div
          initial={{ opacity: 0, scale: 0.2 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            duration: 0.6,
            ease: [0.25, 0.46, 0.45, 0.94],
          }}
          className="w-full relative flex flex-col flex-grow"
        >
          {/* <div className="absolute z-[2000] top-10 right-4">
          {sound ? (
            <GiSoundOn
              className="text-3xl text-primary-main"
              onClick={() => {
                setSound(false);
                stop();
              }}
            />
          ) : (
            <GiSoundOff
              className="text-3xl text-primary-main"
              onClick={() => {
                setSound(true);
                play();
              }}
            />
          )}
        </div> */}
          <div>
            <div className="relative flex items-center justify-center mb-10">
              <Arrow
                onClick={() => navigate(-1)}
                stroke="#fff"
                className="text-lg absolute left-0 cursor-pointer"
              />
              <h4 className="font-medium text-xl text-center flex-grow ">
                Profile Settings
              </h4>
            </div>

            <div className="mb-10 relative grid justify-items-center">
              <div className="relative">
                {profile?.profile_image ? (
                  <div className="p-0.5 border-gradient rounded-full w-fit">
                    <img
                      className="w-[120px] h-[120px] object-cover rounded-full"
                      src={profile?.profile_image}
                      alt="Profile_image"
                      loading="lazy"
                    />
                  </div>
                ) : (
                  <Avatar
                    firstName={profile?.first_name}
                    lastName={profile?.last_name}
                    className="w-[120px] h-[120px] !text-3xl"
                  />
                )}
                <div className=" bg-white w-8 h-8 flex justify-center items-center rounded-full absolute bottom-[3px] right-[3px]">
                  {isUploading ? (
                    <div className="grid place-self-center h-full">
                      <Loader
                        type="spinningBubbles"
                        color="#2741d6"
                        width="20px"
                        height="20px"
                      />
                    </div>
                  ) : (
                    <Camera />
                  )}

                  <label
                    htmlFor="profileImage"
                    className="absolute z-10 w-full h-full opacity-0 cursor-pointer"
                  >
                    <input
                      onChange={(e) => {
                        e.preventDefault();
                        const selectedFile =
                          e.target.files && e.target.files[0];
                        if (selectedFile) {
                          handleUploadProfileImage(selectedFile);
                        }
                      }}
                      type="file"
                      id="profileImage"
                      className="hidden"
                      name="image"
                      accept=".jpg, .png"
                    />
                  </label>
                </div>
              </div>
            </div>

            <Card>
              <BaseInput
                label="First Name"
                placeholder="First Name"
                inputClass="bg-[#F8F8F8]"
                className="mb-5"
                value={firstName ?? ""}
                onChange={(e) => setFirstName(e.target.value)}
              />
              <BaseInput
                label="Last Name"
                placeholder="Last Name"
                inputClass="bg-[#F8F8F8]"
                className="mb-5"
                value={lastName ?? ""}
                onChange={(e) => setLastName(e.target.value)}
              />
              <BaseInput
                label="Email address"
                placeholder="Email"
                inputClass="bg-[#F8F8F8]"
                className="mb-5"
                value={profile.email ?? ""}
                disabled
              />

              <PhoneInput
                value={telePhone}
                onChange={handlePhoneChange}
                inputClass="bg-[#F8F8F8]"
                className="mb-5"
              />
            </Card>

            <div className="mt-12">
              <Button
                disabled={!isValid}
                text={isLoading ? <Loader type="bubbles" /> : "Save"}
                className={isLoading && "!py-0"}
                onClick={handleEditProfile}
              />
            </div>
          </div>
        </motion.div>
      </div>
    </AppLayout>
  );
}

export default UserProfile;
